import Sondage from "../components/Welcome/Others/Sondage";

const HomePage = () => {
    return (
        <Sondage />
    );
};


export default HomePage;